/****************************************************
 * Module Name:  labTesting.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import LabTestingComponent from "../common/labTestingComponent";

const LabTesting = () => {
  return (
    <div>
      <LabTestingComponent
        closeStatus={false}
        reportLoad={false}
        userDropdown={false}
      />
    </div>
  );
};

export default LabTesting;
